"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorderFromProps = exports.getBorder = void 0;
exports.getBorder = (theme, error, focused, readOnly) => {
    if (error) {
        return `1px solid ${theme.color.danger}`;
    }
    if (focused) {
        return `1px solid ${theme.color.primary}`;
    }
    if (readOnly) {
        return `1px solid ${theme.input.borderColor}`;
    }
    return `1px solid ${theme.input.borderColor}`;
};
exports.getBorderFromProps = (props) => {
    return exports.getBorder(props.theme, props.error, props.focused, props.readOnly);
};
